module.exports = __webpack_public_path__ + "img/sfq-h2.e72b84f1.png";